import { Link } from "react-router-dom";
import styled from "styled-components";
import { colors } from "../../theme/color";
import fipayFonts from "../../theme/index";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
`;

export const CoverContainer = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 30px;
`;

export const TopContainer = styled.div`
  padding: 1rem 1rem 0rem 8rem;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.2rem;
  gap: 2rem;

  @media (max-width: 1024px) {
    padding: 1rem 1rem 1rem 3rem;
  }

  @media (max-width: 768px) {
    padding: 1rem 1rem 2rem 2rem;
  }
`;
export const TypeOfAccountBackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-image: url("/assets/icons/hero-landingPage.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  img {
    width: 100%;
    height: 100vh;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const NestedModalContainer = styled.div`
  background-color: white;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 50%;
  // height: 530px; /* Set a maximum height */
  overflow-y: auto; /* Enable vertical scrolling */
  margin: 0rem 2rem 4rem 2rem;

  @media (max-width: 900px) {
    width: 80%;
  }
`;

export const TypeOfAccountModal = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  gap: 30px;
  justify-content: center;
`;

export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const GoBackText = styled.span`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  cursor: pointer;
  color: #09005b;
  margin-left: 2px;
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  }
`;

export const TypeOfAccountTextContainer = styled.div`
  @media screen and (max-width: 430px) {
    margin-top: 30px;
  }
  @media screen and (max-width: 375px) {
    margin-top: 4px;
  }
  @media screen and (max-width: 360px) {
    margin-top: 3px;
  }
`;

export const CardsContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  padding-top: 15px;
  @media screen and (max-width: 768px) {
    width: 90%;
  }

  @media screen and (max-width: 480px) {
    width: 90%;
  }

  @media screen and (max-width: 390px) {
    padding-top: 0px;
  }

  @media screen and (max-width: 375px) {
    width: 90%;
    // height: 50%;
    padding-top: 0px;
  }
`;

export const TypeOfAccountInformation = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.heading2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter: 0.5%;
  color: ${colors.NAVYBLUE};
  font-family: "Gt Walsheim Pro", sans-serif;
  @media screen and (max-width: 768px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 480px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 375px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body4};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }

  @media screen and (max-width: 280px) {
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body1};
    letter-spacing: 1px;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
    text-align: center;
  }
`;

export const TypeOfAccountCreateText = styled.div`
  text-align: center;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter: 2%;
  margin-top: 15px;
  color: ${colors.DARK_GRAY};
  font-family: "Gt Walsheim Pro", sans-serif;

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 90%;
    text-align: center;
    margin-top: 15px;
    margin-left: 20px;
    letter-spacing: 0.2px;
  }
`;

export const TypeOfButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 40px;
  @media screen and (max-width: 375px) {
    padding-top: 9.7px;
  }
  @media screen and (max-width: 360px) {
    padding-top: 15px;
  }

  @media screen and (max-width: 412px) and (max-height: 915px) {
    width: 100%;
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};
    margin-top: 10px;
  }
`;

export const AlreadyHaveAccount = styled.div`
  padding-top: 20px;
  display: flex;
  justify-content: center;
`;

export const LogText = styled(Link)`
  color: #00a602;
  padding-left: 4px;
  font-family: "Gt Walsheim Pro", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  line-height: 24px;
  letter-spacing: 0.32px;
  text-decoration: none;
  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body4};
    line-height: 0px;
  }
`;

export const HeaderContainer = styled.div`
  img {
    height: auto;
    cursor: pointer;
  }
`;

export const AlreadyText = styled.div`
  font-family: "GT Walsheim Pro", "Segoe UI", "Roboto", "Arial", sans-serif;
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-style: normal;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  line-height: 24px;
  letter-spacing: 0.32px;
  @media screen and (max-width: 375px) {
    font-size: ${fipayFonts.fipayFonts.fontSize.body4};
    line-height: 0px;
  }
`;
